import { Reveal } from "./Reveal";
import { LotusMark } from "./LotusMark";

export const ContactBlock = () => (
  <section id="contact" className="py-32 md:py-48">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="max-w-4xl">
        <Reveal>
          <span className="gt-eyebrow">Contact</span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1] text-[var(--gt-ivory)]">
            Ready to release the stress you carry?
            <span className="block gt-gold-text italic">Reach out to Marisol.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-16 flex items-center gap-6">
            <LotusMark size={44} />
            <a
              href="tel:2109989393"
              data-testid="contact-phone-link"
              className="gt-link font-serif text-5xl sm:text-6xl md:text-7xl font-light tracking-tight text-[var(--gt-ivory)]"
            >
              210 · 998 · 9393
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="mt-10 flex flex-wrap items-center gap-x-10 gap-y-3">
            <a
              href="https://thegoldentouchbymarisol.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-website-link"
              className="gt-link gt-gold-text text-sm tracking-wide"
            >
              thegoldentouchbymarisol.com
            </a>
            <span className="gt-eyebrow">10+ Years Experience · All Body Types & Sizes</span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
